/* eslint-disable */
const fs = require('fs')
const path = require('path')
const dir = path.resolve('./src/assets/');
console.log(dir);
const picArr = ['.png','.jpg','.jpeg','.webp','.gif'];
const outPut = {
  'manifest':[]
};
fs.readdir(dir, function (err, files) {
  files.forEach(file => {
    let tmp = path.resolve(dir, file),ext = path.extname(file),isImage = picArr.includes(ext);
    if(isImage){
      let id = path.basename(file,ext).replace(/-(\w)/ig,function(){
        return arguments[1].toUpperCase();
      });;
      let obj = {};
      obj.id = id;
      obj.src =  `assets/${file}`;
      if(file.indexOf('training')>0 || file.indexOf('lazyload')>0 || (file.indexOf('brand')>0 && file.indexOf('cover')<0)) {
        obj.lazyload = true;
      }
      outPut['manifest'].push(obj)
    }
  })
  fs.writeFile(path.resolve(dir,'resources.json'),JSON.stringify(outPut,null,'\t'),function(err) {
    console.log(err)
  })
})


